<div class="app-container">
  <page-header [icon]="'far-industry'" [title]="'brands.list'">
    <ng-container class="header-button">
      @if (canCreate()) {
        <btn
          [routerLink]="['/producer']"
          [classes]="['btn-first', 'float-right']"
          [label]="'brand.create'"
          [title]="'brand.create' | translate"
          [icon]="'far-plus'"
          [dataCyAttribute]="'go-producer'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="filters()"
      [filtersForExport]="filters()"
      [entity]="'producers'"
      (onSubmit)="queryProducers.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [totalItems]="totalItems()"
    >
      <form-row-input
        [label]="'producers.name'"
        [icon]="'far-list'"
        [model]="filters().name"
        (modelChange)="setFilters('name', $event)"
        (keydown.enter)="queryProducers.refetch()"
        [dataCyAttribute]="'producer-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'producers'"
      [query]="queryProducers"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
